import { render, staticRenderFns } from "./LiveQuizHost.vue?vue&type=template&id=209a1605&scoped=true"
import script from "./LiveQuizHost.vue?vue&type=script&lang=js"
export * from "./LiveQuizHost.vue?vue&type=script&lang=js"
import style0 from "./LiveQuizHost.vue?vue&type=style&index=0&id=209a1605&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209a1605",
  null
  
)

export default component.exports